import { isEmpty, isNull } from 'lodash'

import { getValueByLanguage } from 'helpers/common'

import type { IReason } from 'features/Ticket'
import type { IName } from 'helpers/model'

interface IResponseReasonContent {
  taskIssueValue: string
  taskTypeValue: string
  pendingReasonValue: string
  completedTaskIssueValue: string
  rejectedReasonValue: string
  closedReasonValue: string
}

export const getReasonContent = (
  taskIssue: IName | null,
  taskType: IName | null,
  pendingReasons: IReason[] | null,
  completedTaskIssue: IName | null,
  rejectedReasons: IReason[] | null,
  closedTaskReasons: IReason[] | null,
): IResponseReasonContent => {
  const checkReason = (reason: IReason[] | null): boolean => {
    return !isNull(reason) && !isEmpty(reason)
  }

  const taskIssueValue = taskIssue
    ? getValueByLanguage(taskIssue.nameTh, taskIssue.nameEn)
    : '-'
  const taskTypeValue = getValueByLanguage(taskType?.nameTh, taskType?.nameEn)
  const pendingReasonValue =
    pendingReasons && checkReason(pendingReasons)
      ? getValueByLanguage(
          pendingReasons[0].reasonTh,
          pendingReasons[0].reasonEn,
        )
      : '-'
  const completedTaskIssueValue = completedTaskIssue
    ? getValueByLanguage(completedTaskIssue.nameTh, completedTaskIssue.nameEn)
    : '-'
  const rejectedReasonValue =
    rejectedReasons && checkReason(rejectedReasons)
      ? getValueByLanguage(
          rejectedReasons[0].reasonTh,
          rejectedReasons[0].reasonEn,
        )
      : '-'
  const closedReasonValue =
    closedTaskReasons && checkReason(closedTaskReasons)
      ? getValueByLanguage(
          closedTaskReasons[0].reasonTh,
          closedTaskReasons[0].reasonEn,
        )
      : '-'

  return {
    taskIssueValue,
    taskTypeValue,
    pendingReasonValue,
    completedTaskIssueValue,
    rejectedReasonValue,
    closedReasonValue,
  }
}
